<!-- 生成页面:page -->
<template>
  <div class="buildTemp">
    <v-page  :page-val="buildData" :key="buildData.id"></v-page>
  </div>
</template>

<script>
import { interfaceObj } from "@/urlConfig";
import page from "@/components/page";
export default {
  name: "buildTemp",
  components:{
    "v-page":page,
  },
  data() {
    return {
      buildData:{},
      searchId:"",//路由id
    };
  },
  created() {
    var that = this;
    that.searchId = that.$route.query.id
    // console.log("this.$router.params.id",this.searchId);
    that.getData();
  }, 
  watch: { 
      $route(){
        var that = this;
        that.searchId = that.$route.query.id
      },
      searchId() {
        var that = this;
        that.getData();
      },
  },
  methods: {
    getData(){
      var that = this;
      that.axios
        .get(interfaceObj.getpage+that.searchId+'/')
        .then((res) => {
          that.buildData = res.data.data;
          // that.navStatus = true;
          console.log("that.homeData",that.buildData);
      });
    },
    // getview(to, from){
    //     this.name = this.$route.query.name 
    // }
  },
};
</script>
<style lang="scss">
.build{
  width:100%;
}
</style>
